<template>
  <section v-if="listaBanners.length > 0">
    <div style="heigth:50px;"></div>    
    <div class="row"> 
      <div class="slider pt-1">
        <div 
          v-for="(banner) in listaBanners" 
          :key="banner.bannId"
          class="slide" :id="'banner_'+banner.bannId" 
          :class="{'show-banner':banner.ativo}"
          @click.stop.prevent="selecionaPagina(banner)" 
          @touchstart.stop.prevent="selecionaPagina(banner)"
        >
          <img class="responsive-img ml-0" :src="banner.bannArquivoBase64" :alt="banner.bannTitulo" style="border-radius: 15px">
        </div>
      </div>
    </div>
    <div class="row" v-if="exibirComponenteBanner">
      <div class="col s12 center" >
        <ul class="carousel-bullet center" style="margin-top:0; margin-bottom:0;">
          <li 
            v-for="(banner) in listaBanners" 
            :key="banner.bannId"
            :id="'bullet_'+banner.bannId" 
            class="waves-effect active" 
            @click.prevent="selecionarNavegacaoBanner(banner.bannId)"
          >
            <span class="grey-text center-align" v-if="banner.ativo"><i class="tiny material-icons center">lens</i></span>
            <span class="grey-text center-align" v-else><i class="tiny material-icons center">panorama_fish_eye</i></span>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import ServiceFactory from '../../services/ServiceFactory';

export default {
  name:'st-carousel',
  props: {
    usuario:null,
    env:null,
    inCatalogo: {type:Boolean, default:false},
  },
  data () {
    return {
      carouselService:null,
      listaBanners:[],
      idRodaCarousel:null,
      tamanhoBanner:0,
      ultimoBannerSelecionado:-1,
      exibirComponenteBanner:false,
      contagemProximoPagina: 0,
      tempoProximoPagina: 4, //segundos
    }
  },
  created () {
    let factory = new ServiceFactory(this.$http);
    factory.carousel()
      .then(service => this.carouselService = service)
      .then(() => {
        if(this.inCatalogo) this.obterImagensCatalogo();
        else this.obterImagens();
      })
      .catch(err => this.$emit('onError', err));
  },
  destroyed() {
    clearInterval(this.idRodaCarousel);
  },
  methods: {
    obterImagens() {
      this.carouselService.obterListaImagensBanner('', this.usuario.empresa.emprId, this.usuario.usuaRole, this.usuario.usuaIdUneg,
          'P', parseInt(this.env.quantidade_paginacao_banner), 0)
        .then(lista => {
            this.listaBanners = lista;
            if(this.listaBanners.length > 0) {
              this.ultimoBannerSelecionado = this.ultimoBannerSelecionado == (this.listaBanners.length - 1) ? 0 : this.ultimoBannerSelecionado + 1;
              this.selecionarNavegacaoBanner(this.listaBanners[this.ultimoBannerSelecionado].bannId);
              this.idRodaCarousel = setInterval(() => {
                if (this.contagemProximoPagina >= this.tempoProximoPagina) {
                  this.ultimoBannerSelecionado = this.ultimoBannerSelecionado == (this.listaBanners.length - 1) ? 0 : this.ultimoBannerSelecionado + 1;
                  this.selecionarNavegacaoBanner(this.listaBanners[this.ultimoBannerSelecionado].bannId);
                  this.contagemProximoPagina = 0;
                }
                this.contagemProximoPagina++;
              }, 1000);
            }
          })
        .catch(err => { 
            this.$emit('onError', err)
          });
    },
    selecionarNavegacaoBanner(bannerId) {
      // window.location     = `#banner_${bannerId}`;
      // document.body.scrollTop = 0;
      // document.documentElement.scrollTop = 0;      
      this.listaBanners.map((bann, index)=>{
        if(bann.bannId == bannerId) {
          bann.ativo = true;
          this.ultimoBannerSelecionado = index >= this.listaBanners.length ? 0 : index;
          this.exibirComponenteBanner = true;
        } else {
          bann.ativo = false;
        }    
      });
    },
    selecionarPromocaoBanner(banner) {
      if (banner.sku ||
        banner.bannSkuf ||
        banner.bannDescricao ||
        banner.bannDescritivo ||
        banner.bannAtrib1 ||
        banner.bannAtrib2 || 
        banner.bannDisp
        ) {
          this.$emit('aoSelecionarBanner',{sku: banner.bannSku, skuf: banner.bannSkuf, descricao:banner.bannDescricao, descritivo:banner.bannDescritivo, atrib1:banner.bannAtrib1, atrib2:banner.bannAtrib2, disp:banner.bannDisp});
        }
    },
    selecionaPagina(banner) {
      const { bannUsarLinkExterno, bannLinkExterno } = banner;
      if(bannUsarLinkExterno && bannLinkExterno && bannLinkExterno.trim().length > 0) {
        this.$emit('onSelecionarBannerExterno', bannLinkExterno);
        return;
      }
      this.selecionarPromocaoBanner(banner);
      this.contagemProximoPagina = 0;
    },
    obterImagensCatalogo() {
      this.carouselService.obterListaImagensBannerCatalogoLogin(
        '', 
        null, 
        null, 
        null, 
        'P', 
        parseInt(this.env.quantidade_paginacao_banner), 
        0
      )
      .then(lista => {
          this.listaBanners = lista;
          if(this.listaBanners.length > 0) {
            this.ultimoBannerSelecionado = this.ultimoBannerSelecionado == (this.listaBanners.length - 1) ? 0 : this.ultimoBannerSelecionado + 1;
            this.selecionarNavegacaoBanner(this.listaBanners[this.ultimoBannerSelecionado].bannId);
            this.idRodaCarousel = setInterval(() => {
              if (this.contagemProximoPagina >= this.tempoProximoPagina) {
                this.ultimoBannerSelecionado = this.ultimoBannerSelecionado == (this.listaBanners.length - 1) ? 0 : this.ultimoBannerSelecionado + 1;
                this.selecionarNavegacaoBanner(this.listaBanners[this.ultimoBannerSelecionado].bannId);
                this.contagemProximoPagina = 0;
              }
              this.contagemProximoPagina++;
            }, 1000);
          }
        })
      .catch(err => { 
        this.$emit('onError', err)
      });
    },
  }
}
</script>

<style>
  .slider {        
    width: 100%;
    height: auto !important;
    cursor: pointer;
  }

  .slide {
    width: 100%;
    display: none;
  }

  .slide img {
    width: 100%;
  }

  .show-banner {
    display: block;    
  }

  .carousel-bullet {
    padding-top: 0;    
  }

  .carousel-bullet li {
    padding: 0;    
    margin-right: 3px;
  }

  @media only screen and (max-width: 600px) {

  .responsive-img {
    height: 8rem !important;
  }

}

</style>





// WEBPACK FOOTER //
// stCarousel.vue?1ab00cd0